import styled from "styled-components";

export const LoginForm = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
  width: 70%;
  margin: auto;
  box-shadow: ${({ theme }) => theme.shadow};
  border-radius: 10px;
  @media (max-width: 760px) {
    width: 90%;
  }

  form {
    margin-top: 2rem;
    width: 70%;

    @media (max-width: 760px) {
      width: 90%;
    }
  }

  /* height: 100%; */
`;

export const Right = styled.div`
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  @media (max-width: 1100px) {
    width: 100%;
  }
`;

export const Left = styled.div`
  width: 50%;
  height: 100%;
  @media (max-width: 1100px) {
    display: none;
  }
`;

export const Img = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;
